import React from 'react'
import Slider from 'react-slick'
import { Link } from 'react-router-dom'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const CustomNextArrow = (props) => {
    const { className, style, onClick } = props
    return (
        <div
            className={className}
            style={{
                ...style,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                background: 'white',
                borderRadius: '50%',
                boxShadow: '0px 0px 6px #d2dce6',
                right: '-10px',
                zIndex: 1,
                width: '40px',
                height: '40px',
                cursor: 'pointer',
            }}
            onClick={onClick}
        >
            <span className="material-icons" style={{ color: 'black' }}>
                east
            </span>
        </div>
    )
}

const CustomPrevArrow = (props) => {
    const { className, style, onClick } = props
    return (
        <div
            className={className}
            style={{
                ...style,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                background: 'white',
                boxShadow: '0px 0px 6px #d2dce6',
                borderRadius: '50%',
                left: '-10px',
                zIndex: 1,
                width: '40px',
                height: '40px',
                cursor: 'pointer',
            }}
            onClick={onClick}
        >
            <span className="material-icons" style={{ color: 'black', rotate: '180deg' }}>
                east
            </span>
        </div>
    )
}

const ProductSlider = (props) => {
    const settings = {
        dots: false,
        infinite: props.type === 'oem' ? false : true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: props.type === 'oem' ? false : true,
        autoplaySpeed: 2000,
        arrows: true,
        nextArrow: <CustomNextArrow />,
        prevArrow: <CustomPrevArrow />,
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 3 } },
            { breakpoint: 768, settings: { slidesToShow: 2 } },
            { breakpoint: 480, settings: { slidesToShow: 1 } },
        ],
    }

    return (
        <div
            className={props.type === 'oem' ? 'imageSliderParent hideButton' : 'imageSliderParent'}
        >
            <Slider {...settings}>{props.children}</Slider>
        </div>
    )
}

export default ProductSlider
